module.exports = __webpack_public_path__ + "3363794eec728d3fd262c652d88cc13e.svg";